const CGU = () => {
  return (
    <>
      <h6 style={{ color: '#A2C523' }}>Conception du site</h6>
      <hr />
      <p>
        Notre site a été conçu et développé par <strong><a href="https://aziz-bennane.fr" target="_blank" style={{ color: '#968E8C' }} title="Développeur fullstack">Aziz BENNANE</a></strong>, en qualité de bénévole,
        pour le compte de l’association <u>Fédération Départementale des Courses Hippiques de Loire Atlantique</u>.
      </p>

      <h6 style={{ color: '#A2C523' }}>Edition du contenu</h6>
      <hr />
      <p>
        Le contenu éditorial du site est publié avec la supervision de <u>Gilbert ROUESSARD</u>, responsable de la communication de l’association.
      </p>

      <h6 style={{ color: '#A2C523' }}>Hébergement</h6>
      <hr />
      <p>
        Le site est hébergé par la société :
        <p>
          <u>IONOS by 1&1</u><br />
          7 place de la Gare<br />
          57200 Sarreguemines<br />
          France<br />
          Site web : <strong><a style={{ color: '#968E8C' }} href="https://www.ionos.fr" target="_blank">https://www.ionos.fr</a></strong>
        </p>
      </p>

      <h6 style={{ color: '#A2C523' }}>Propriété intellectuelle</h6>
      <hr />
      <p>
        L’ensemble des éléments présents sur le site (textes, photographies,
        logos, documents, graphismes, vidéos, etc.) est protégé par les dispositions
        du Code de la propriété intellectuelle.
      </p>
      <p>
        Toute reproduction, représentation, modification, publication ou adaptation,
        totale ou partielle, des contenus du site, quel que soit le moyen ou le procédé
        utilisé, est interdite sans l’autorisation écrite préalable de l’association.
      </p>
      <p>
        La navigation sur le site implique l’acceptation pleine et entière des
        conditions générales d’utilisation.
      </p>

      <h6 style={{ color: '#A2C523' }}>Cookies</h6>
      <hr />
      <p>
        Le site utilise uniquement des cookies strictement nécessaires à son bon
        fonctionnement (cookies techniques).
      </p>
      <p>
        Ces cookies ne collectent aucune donnée personnelle et ne sont pas utilisés
        à des fins de suivi ou de statistiques.
      </p>
      <p>
        Conformément à la réglementation en vigueur, ces cookies ne nécessitent pas
        le consentement préalable de l’utilisateur.
      </p>

      <h6 style={{ color: '#A2C523' }}>Données personnelles</h6>
      <hr />
      <p>
        Les données personnelles collectées via le site le sont exclusivement
        dans le cadre des formulaires suivants :
      </p>
      <ul>
        <li>Formulaire de contact</li>
        <li>Formulaire d’engagement au sein de l’association</li>
      </ul>

      <p>
        Les données collectées peuvent inclure :
      </p>
      <ul>
        <li>Nom</li>
        <li>Adresse électronique (email)</li>
        <li>Entreprise ou organisme (le cas échéant)</li>
      </ul>

      <p>
        Ces données sont utilisées uniquement pour répondre aux demandes des
        utilisateurs et gérer les engagements associatifs.
        Elles sont transmises par courrier électronique aux responsables
        habilités de l’association et ne font l’objet d’aucune cession à des tiers.
      </p>

      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD),
        les utilisateurs disposent d’un droit d’accès, de rectification, d’opposition,
        de limitation et de suppression de leurs données.
      </p>

      <p>
        Toute demande relative à l’exercice de ces droits peut être adressée à :
        <u>kiki.rodeo@orange.fr</u>.
      </p>

      <h6 style={{ color: '#A2C523' }}>Liens externes</h6>
      <hr />
      <p>
        Les liens hypertextes externes existants sur notre site <u>www.chr44.fr</u>, et qui redirigent vers des sites tiers n’engagent pas la responsabilité de notre association, ni celle de l’éditeur de notre site.
      </p>
      <p>
        Nous n'exerçons aucun contrôle sur leur contenu, leur disponibilité ou leur degré de confiance conformément à la loi n°2004-575 du 21 juin 2004 pour la confiance dans l’économie numérique.
      </p>
    </>
  );
}

export default CGU;
